import { useCallback, useContext } from "react"

import { Link } from "expo-router"

import { Connector, ConnectorCollection, Index } from "wealthmode-frontend/backend"
import { Box, Image, Text } from "wealthmode-frontend/gluestack/ui"

import { DataTable, IDLink } from "@/components"
import { BackendContext } from "@/context"
import { logoDataURL } from "@/lib/logo"

export default function Connectors() {
  const backend = useContext(BackendContext)

  const load = useCallback(async () => {
    var data = backend.link("data").resolve() as Index
    await data.fetch({ reload: true })

    var connectors = data.link("connectors")?.resolve() as ConnectorCollection | undefined
    if (!connectors) {
      return undefined
    }

    await connectors.fetch({ reload: true })

    return connectors
  }, [backend])

  return (
    <Box className="flex flex-1 min-h-0 flex-col">
      <DataTable
        title={"Connectors"}
        load={load}
        search={{ mode: "remote" }}
        header={[
          { id: "id", title: "ID", shrink: true },
          { id: "provider", title: "Provider", shrink: true },
          { id: "logo", title: "", shrink: true, center: true, noTruncate: true },
          { id: "name", title: "Name" },
          { id: "domain", title: "Domain" },
          { id: "status", title: "Status", shrink: true },
          { id: "links", title: "", shrink: true, noTruncate: true },
        ]}
        render={(model: Connector, field: string) => {
          switch (field) {
            case "id":
              return (
                <IDLink
                  href={`/connectors/${model.id}`}
                  id={model.id}
                />
              )

            case "logo": {
              const sizeClasses = "h-16 w-16"
              const logo = logoDataURL(model.attributes.image_base64)
              if (!logo) {
                return <Box className={sizeClasses} />
              }

              return (
                <Image
                  source={{ uri: logo }}
                  alt={`${model.attributes.name} logo`}
                  className={sizeClasses}
                  resizeMode="contain"
                />
              )
            }

            case "domain":
              try {
                return new URL(model.attributes.url).hostname
              } catch (e) {
                return model.attributes.url
              }

            case "status":
              return model.attributes.active ? "Active" : "Inactive"

            case "links":
              return (
                <Link href={`/connectors/${model.id}`}>
                  <Text className="text-markdown-link hover:opacity-80 underline">Curate</Text>
                </Link>
              )
          }

          return model.get(field)
        }}
      />
    </Box>
  )
}
